import React from "react";
import {  PageHeader, TeamMember } from "../../components";
import OtherGamesGallery from "./directory/otherGames";
import style from "./style.module.css";
export default function OtherGames() {
  return (
    <div className="page-content">
      <PageHeader title="Other games" page="other-games" />
      {/* <!-- Content --> */}
      <div className="page-content">
        {/* <!-- contact -> */}
        <div className="content">
          {/* <!-- About Company --> */}
          {/* <!-- Our Awesome Services --> */}
          <div className="section-full bg-gray content-inner ">
            <div className="container">
              <div className="row">
                <div className="col-md-12 text-center section-head mamber-dec">
                  <h3 className="h2">WELCOME TO OTHER GAMES</h3>
                  <div className="dlab-separator bg-primary"></div>
                  <div className="clear"></div>
                  <h5 class="font-weight-3 m-b30">Other Games Section is one of the ten sections of Lagos Country Club. This is the section where indoor and exciting games are played. It is a Section where youth and aged members engage in games that tasks the mind. You task your brain because the games make you think and plan on how you can outsmart your opponent. The environment of the Section is good for fun, relaxation and entertainment.  You play game while listening to soft music and banters among members. The camaraderie of members coupled with the ambience of the environment add to the friendly atmosphere to give members a unique experience.  It is a section to belong. We have five major indoor games namely Draught, Chess, Ayo, Ludo and WHOT. You can play other games like monopoly, snake ladder etc. We play games for fun and entertainment to relax our minds after a tough day’s job.</h5>
                  {/* <a href="/#" className="site-button">Learn More</a> */}
                </div>
              </div>
            </div>
          </div>
          {/* <!-- About Company END --> */}
            {/* <!-- Gallery section --> */}
            <OtherGamesGallery />
          {/* <!-- Gallery section END --> */}

          {/* <!-- Team member --> */}
          <TeamMember
            name="MR TUNJI AKINWANDE"
            title="Chairman For Other Games"
            img="./assets/images/members/LCC_CHAIRMAN_OTHER_GAMES.jpg"
          />
          {/* <!-- Team member --> */}
        </div>
        {/* <!-- contact area  END --> */}
      </div>
    </div>
  );
}
